import React, { useState, Suspense, lazy } from 'react';
import { FaBan, FaCheckCircle, FaShareSquare } from 'react-icons/fa';
import { Alert, Button } from 'components/common';
import ChangeOrderFinalRequestSchedule from './ChangeOrderFinalRequestSchedule';
import PropTypes from 'prop-types';

const LazyChangeOrderAcceptConfirmation = lazy(() => import('./confirmation/ChangeOrderAcceptConfirmation'));
const LazyChangeOrderRejectConfirmation= lazy(() => import('./confirmation/ChangeOrderRejectConfirmation'));
const LazyChangeOrderRequestConfirmToCSD = lazy(() => import('./confirmation/ChangeOrderRequestConfirmToCSD'));

const ChangeOrderDetailMessageAction = ({changeOrder}) => {
  const [showAcceptConfirmation, setShowAcceptConfirmation] = useState(false);
  const [showRejectConfirmation, setShowRejectConfirmation] = useState(false);
  const [requestConfirmationToCSD, setRequestConfirmationToCSD] = useState(false);
  const [requestFullScheduleToENG, setRequestFullScheduleToENG] = useState(false);

  const {building, permissions} = changeOrder || {};

  const {
    allow_request_confirm,
    allow_confirm
  } = permissions || {};

  const handleAcceptCO = () => {
    setShowAcceptConfirmation(true)
  }

  const handleRejectCO = () => {
    setShowRejectConfirmation(true)
  }

  const handleRequestConfirmToCSD = () => {
    setRequestConfirmationToCSD(true)
  }

  //show form request schedule to ENG directly
  const handleRequestScheduleToENG = () => {
    setRequestFullScheduleToENG(true);
  }

  return (
    <>
    {allow_request_confirm && (
      <Alert type="warning" className="tw-mb-3">
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
          <span>This change order hasn't been sent to CSD yet.</span>
          <Button
            variant="primary"
            size="sm"
            leftIcon={FaShareSquare}
            onClick={handleRequestConfirmToCSD}
          >
            Request confirmation to CSD right now!
          </Button>
        </div>
      </Alert>
    )}

    {allow_confirm && (
      <Alert type="info" className="tw-mb-3">
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
          <span>Waiting confirmation by <strong>{building?.cse_order_entry.join("/")}!</strong></span>
          <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-1">
            <Button
              variant="success"
              size="sm"
              leftIcon={FaCheckCircle}
              onClick={handleAcceptCO}
            >
              Accept
            </Button>

            <Button
              variant="danger"
              size="sm"
              leftIcon={FaBan}
              onClick={handleRejectCO}
            >
              Reject
            </Button>
          </div>
        </div>
      </Alert>
    )}

    <Suspense fallback={<div>Loading...</div>}>
      {showAcceptConfirmation && (
        <LazyChangeOrderAcceptConfirmation
          showModal={showAcceptConfirmation}
          setshowModal={setShowAcceptConfirmation}
          changeOrder={changeOrder}
          requestScheduleToENG={handleRequestScheduleToENG}
        />
      )}

      {showRejectConfirmation && (
        <LazyChangeOrderRejectConfirmation
          showModal={showRejectConfirmation}
          setshowModal={setShowRejectConfirmation}
          changeOrder={changeOrder}
        />
      )}

      {requestConfirmationToCSD && (
        <LazyChangeOrderRequestConfirmToCSD
          showModal={requestConfirmationToCSD}
          setshowModal={setRequestConfirmationToCSD}
          changeOrder={changeOrder}
        />
      )}

      {requestFullScheduleToENG && (
        <ChangeOrderFinalRequestSchedule
          showModal={requestFullScheduleToENG}
          setshowModal={setRequestFullScheduleToENG}
          changeOrder={changeOrder}
          title="Request schedule to ENG"
          isScheduled={false}
        />
      )}
    </Suspense>
  </>
  )
};

ChangeOrderDetailMessageAction.propTypes = {
  changeOrder: PropTypes.object.isRequired
};

export default ChangeOrderDetailMessageAction
